import React from "react";
import classes from './SelectDropdown.css';
import Select from 'react-select';

const SelectDropdown = ({
    customHeight,
    customWidth = '150px',
    width,
    height,
    name,
    defaultValue,
    value,
    options,
    isSearchable,
    onChange,
    placeholder,
    id,
    key
  }) => {
    const controlWidth = width || customWidth;
    const controlHeight = height || customHeight || '30px';
    return (
        <Select
          key={key}
          id={id}
          className={name}
          classNamePrefix={name}
          defaultValue={defaultValue}
          name={name}
          options={options}
          isSearchable={isSearchable}
          onChange={onChange}
          placeholder={placeholder}
          value={value}
          styles={{
            control:(base) => ({
              ...base,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              minHeight: controlHeight,
              height: controlHeight,
              width: controlWidth,
              padding: '0',
            }),
            menu:(base) => ({
              ...base,
              width: controlWidth,
            }),
            valueContainer:(base) => ({
              ...base,
              width: controlWidth,
              display:'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              padding: '0 8px',
            }),
            singleValue:(base) => ({
              ...base,
              textAlign: 'left',
            }),
            placeholder:(base) => ({
              ...base,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }),
            dropdownIndicator:(base) => ({
              ...base,
              padding:'0',
              display:'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }),
            indicatorSeparator: () => ({ display: "none" }),
            indicatorsContainer: (provided) => ({
              ...provided,
              height: controlHeight,
            }),
          }}
        />
    )
}

export default SelectDropdown;
